import {combineReducers} from 'redux';
import auth from './modules/Authentication/AuthenticationReducer';
import upcomingSchedules from './modules/Dashboard/DashboardReducer';

// Combine all reducers into one root reducer
export default combineReducers({
    auth,
    upcomingSchedules
});
